/**
 * package: com.inq.ui
 * class: VideoTag
 * @extends com.inq.ui.Container
 * @constructor
 */
com.inq.ui.VideoTag = function(id) {
	com.inq.ui.Container.call(this, id);
	/*
	 Always try to have a parent element with size in 4:3 aspect ration. Video element always maintains aspect ratio.
	 */
	if(!com.inq.utils.Util.getConfig("isVidyo", true)) {
		this._div.innerHTML =
			"<video id='videoInOut' autoplay width='100%' height='100%' style='position:absolute;' poster='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'></video>";
	}
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.VideoTag, "com.inq.ui.VideoTag");

com.inq.ui.VideoTag.prototype.buildStyle = function() {
	com.inq.ui.Container.prototype.buildStyle.call(this);
};

com.inq.ui.VideoTag.prototype.applyStyle = function() {
	com.inq.ui.Container.prototype.applyStyle.call(this);
};
